import logo from "./logo.svg";
import "./assets/scss/app.scss";
import { useState } from "react";

function App() {
  const [loginId, setLoginId] = useState("api-sandbox3469");
  const [password, setPassword] = useState('FlexEcom@2026');

  const [firstName, setFirstName] = useState("Testing");
  const [lastName, setLastName] = useState("Stripe");
  const [email, setEmail] = useState("test@yopmail.com");
  const [phone, setPhone] = useState("19876543206");

  const [isLoading, setIsLoading] = useState(false);

  const [productId, setProductId] = useState("2");
  const [productQuantity, setProductQuantity] = useState(Math.floor(Math.random() * 100));

  const [cardNumber, setCardNumber] = useState("4539225011794489");
  const [expiryMonth, setExpiryMonth] = useState("12");
  const [expiryYear, setExpiryYear] = useState("30");
  const [cvv, setCVV] = useState("999");
  const [countryCode, setCountryCode] = useState("US");
  const [merchantInitiated, setMerchantInitiated] = useState(false);

  const [events, setEvents] = useState([]);

  const processPayment = async () => {

    setIsLoading(true);
    setEvents([])
    try {
      const baseUrl = 'https://sandbox-api.checkoutchamp.com/order/import/';

      const params = new URLSearchParams({
        loginId: loginId,
        password: password,
        firstName: firstName,
        lastName: lastName,
        emailAddress: email,
        phoneNumber: phone,
        address1: '347 Lavender Road',
        address2: 'Flat 6 Primrose Rise',
        country: countryCode,
        state: 'NY',
        city: 'New York',
        postalCode: '81012',
        billShipSame: '1',
        paySource: 'CREDITCARD',
        campaignId: '1',
        product1_id: productId,
        product1_qty: productQuantity,
        userAgent: "userAgent",
        cardNumber: cardNumber,
        cardMonth: expiryMonth,
        cardYear: 2030,
        cardSecurityCode: cvv,
        redirectsTo: 'https://dev.extremegadgetz.com/sachin-rebilling-test/catalog.php',
        errorRedirectsTo: 'https://dev.extremegadgetz.com/sachin-rebilling-test/catalog.php'
      });

      setEvents([
          {
            _type: "loading"
          },
        ]
      )

      const response = await fetch(`${baseUrl}?${params.toString()}`, { method: 'POST' })

      const responseJson = await response.json();
      if(responseJson.result === "SUCCESS"){
        setEvents((prev) => [
            ...prev,
            {
              _type: "completed"
            }
          ]
        )
      } else {
        setEvents((prev) => [
            ...prev,
            {
              _type: "failed"
            }
          ]
        )
      }

    } catch (error) {
      alert("Oops: " + JSON.stringify(error.response?.data || {}));
      setEvents((prev) => [
          ...prev,
          {
            _type: "failed"
          }
        ]
      )
    } finally {
      setIsLoading(false);
    }
  };

  const renderCards = () => {
    return (
      <>
        <div className="mw-325px">
          <h3>Test Payment Portal</h3>
          <p className="mb-0">
            To test the payment, please fill in the required details on the
            right side
          </p>
        </div>
        <div className="alert alert-light">
          <b>Checkout Champ</b>
          <table className="table table-borderless text-start fs-6 fw-medium mb-3">
            <tbody>
            <tr>
              <td>Success:</td>
              <td>4242424242424242</td>
            </tr>
            <tr>
              <td>Success (Cured):</td>
              <td>4539225011794489</td>
            </tr>
            <tr>
              <td>Failure (Not Cured):</td>
              <td>4000008260003178</td>
            </tr>
            </tbody>
          </table>

        </div>
      </>
    )
  }

  const renderEvents = () => {
    return events.map((event, i) => {
      console.log("Events", events)
      if (event._type === "loading") {
        return (
          <div className="alert alert-info mb-0 text-start w-100">
            <h6>Payment Attempt</h6>
            <div>Calling Checkout Champ Api</div>
          </div>
        )
      }
      else if(event._type === "completed"){
        return (
          <div className="alert alert-success mb-0 text-start">
            <h6>Payment Cured!</h6>
            <div>Status: Success</div>
          </div>
        )
      }else if(event._type === "failed"){
        return (
          <div className="alert alert-danger mb-0 text-start">
            <h6>Payment Failed</h6>
            <div>Status: Failed</div>
          </div>
        )
      }

      return null
    })
  }

  return (
    <div className="page demo">
      <div className="onboarding">
        <div className="onb-aside w-100">
          <div class="t-section">
            <a href="javascript:void(0)">
              <img alt="Logo" src="logo.png" className="h-40px"/>
            </a>
            {(!isLoading && events.length === 0) && renderCards()}
            {renderEvents()}
            {isLoading && (
              <>
                <div className="alert mb-0">
                  <h6>Loading...</h6>
                </div>
              </>
            )}
          </div>
        </div>
        <div className="onb-body">
          <div className={"form"}>
            {/* Starts: Merchant Details */}
            <div className={"s-card"}>
              <label className="form-label">Checkout Champ</label>
              <div className="row">
                <div className="col">
                  {/* Starts: Merchant Credents */}
                  <div className="form-group">
                    <label className="form-label fw-normal">
                      Login Id
                    </label>
                    <input
                      className="form-control"
                      placeholder="Login Id"
                      value={loginId}
                      onChange={(e) => setLoginId(e.target.value || null)}
                    />
                  </div>
                </div>
                <div className="col">
                  <div className="form-group">
                    <label className="form-label fw-normal">
                      Password
                    </label>
                    <input
                      className="form-control"
                      placeholder="Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value || null)}
                    />
                  </div>
                </div>
              </div>
              {/* end: Merchant Credentials */}
              {/* Starts: Product Id,Product Quantity  */}
              <div className="row">
                <div className="col">
                  <div className="form-group">
                    <label className="form-label fw-normal">Product Id*</label>
                    <input
                      className="form-control"
                      placeholder="Product Id"
                      value={productId}
                      type={"number"}
                      onChange={(e) => setProductId(e.target.value || null)}
                    />
                  </div>
                </div>
                <div className="col">
                  <div className="form-group">
                    <label className="form-label fw-normal">Product Quantity*</label>
                    <input
                      className="form-control"
                      placeholder="Product Quantity"
                      value={productQuantity}
                      type={"number"}
                      onChange={(e) => setProductQuantity(e.target.value || null)}
                    />
                  </div>
                </div>
              </div>
              {/* end: Product Id,Product Quantity */}
            </div>
            {/* End: Merchant Details */}

            {/* Starts: Card Details */}
            <div className={"s-card"}>
              <label className="form-label">Card Details</label>
              {/* Starts: Card Number* */}
              <div className="form-group">
                <label className="form-label fw-normal">Card Number*</label>
                <input
                  className="form-control"
                  placeholder="Card Number"
                  value={cardNumber}
                  onChange={(e) => setCardNumber(e.target.value || null)}
                />
              </div>
              {/* end: Card Number* */}
              {/* Starts: Month, Year, CVV */}
              <div className="row">
                <div className="col">
                  <div className="form-group">
                    <label className="form-label fw-normal">Exp Month*</label>
                    <select
                      className="form-control"
                      value={expiryMonth}
                      onChange={(e) => setExpiryMonth(e.target.value || null)}
                    >
                      <option value={"01"}>01</option>
                      <option value={"02"}>02</option>
                      <option value={"03"}>03</option>
                      <option value={"04"}>04</option>
                      <option value={"05"}>05</option>
                      <option value={"06"}>06</option>
                      <option value={"07"}>07</option>
                      <option value={"08"}>08</option>
                      <option value={"09"}>09</option>
                      <option value={"10"}>10</option>
                      <option value={"11"}>11</option>
                      <option value={"12"}>12</option>
                    </select>
                  </div>
                </div>
                <div className="col">
                  <div className="form-group">
                    <label className="form-label fw-normal">Exp Year*</label>
                    <select
                      className="form-control"
                      value={expiryYear}
                      onChange={(e) => setExpiryYear(e.target.value || null)}
                    >
                      <option value={"25"}>2025</option>
                      <option value={"26"}>2026</option>
                      <option value={"27"}>2027</option>
                      <option value={"28"}>2028</option>
                      <option value={"29"}>2029</option>
                      <option value={"30"}>2030</option>
                    </select>
                  </div>
                </div>
                <div className="col">
                  <div className="form-group">
                    <label className="form-label fw-normal">CVV*</label>
                    <input
                      className="form-control"
                      value={cvv}
                      onChange={(e) => setCVV(e.target.value || null)}
                    />
                  </div>
                </div>
              </div>
              {/* end: Month, Year, CVV */}
            </div>
            {/* End: Card Details */}

            {/* Starts: Customer Details */}
            <div className={"s-card"}>
              <label className="form-label">Customer Details</label>
              {/* Starts: First and Last Names */}
              <div className="row">
                <div className="col">
                  <div className="form-group">
                    <label className="form-label fw-normal">First Name</label>
                    <input
                      className="form-control"
                      placeholder="first_name"
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value || null)}
                    />
                  </div>
                </div>
                <div className="col">
                  <div className="form-group">
                    <label className="form-label fw-normal">Last Name</label>
                    <input
                      className="form-control"
                      placeholder="last_name"
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value || null)}
                    />
                  </div>
                </div>
              </div>
              {/* end: First and Last Names */}
              {/* Starts: Email and Phone */}
              <div className="row">
                <div className="col">
                  <div className="form-group">
                    <label className="form-label fw-normal">Email</label>
                    <input
                      className="form-control"
                      placeholder="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value || null)}
                    />
                  </div>
                </div>
                <div className="col">
                  <div className="form-group">
                    <label className="form-label fw-normal">Phone</label>
                    <input
                      className="form-control"
                      placeholder="phone"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value || null)}
                    />
                  </div>
                </div>
              </div>
              {/* end: Email and Phone */}
            </div>
            {/* End: Customer Details */}
            {/* Starts: MIT Details */}
            <div className={"s-card"}>
              <label className="form-label">Transaction Type</label>
              <div className="row">
                <div className="col">
                  <div className="form-group">
                    <select
                      className="form-control"
                      value={merchantInitiated}
                      onChange={(e) => setMerchantInitiated(e.target.value)}
                    >
                      <option value={false}>Customer Initiated</option>
                      <option value={true}>Merchant Initiated</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            {/* End: MIT Details */}
            <div className="gap"></div>
            <button
              className="btn btn-primary w-100"
              type="submit"
              disabled={isLoading}
              onClick={processPayment}
            >
              {isLoading ? "Loading..." : "Submit"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
